import { create } from 'zustand'
import { createJSONStorage, devtools, persist } from 'zustand/middleware'
import { zustandPlugin } from '@/modules/shared/openreplay'
import { SelectedDriver } from '@/app/types/creator'


export type CreatorSelectionState = {
  companyId: string | null
  month: string | null
  selectedDrivers: SelectedDriver[]
}

type SetSelectedDriversAction =
  | SelectedDriver[]
  | ((prev: SelectedDriver[]) => SelectedDriver[])

type Actions = {
  setSelectedDrivers: (action: SetSelectedDriversAction) => void
  syncContext: (companyId: string | null, month: string | null) => void
  clear: () => void
}

const initialState: CreatorSelectionState = {
  companyId: null,
  month: null,
  selectedDrivers: [],
}

export const useCreatorSelectionStore = create<
  CreatorSelectionState & Actions
>()(
  devtools(
    persist(
      zustandPlugin(
        (set) => ({
          ...initialState,
          setSelectedDrivers: (action) =>
            set(
              (state) => ({
                selectedDrivers:
                  typeof action === 'function'
                    ? action(state.selectedDrivers)
                    : action,
              }),
              false,
              'setSelectedDrivers',
            ),
          syncContext: (companyId, month) =>
            set(
              (state) => {
                if (
                  state.companyId === companyId &&
                  state.month === month
                ) {
                  return state
                }
                return { companyId, month, selectedDrivers: [] }
              },
              false,
              'syncContext',
            ),
          clear: () => set({ ...initialState }, false, 'clear'),
        }),
        'creator-selection',
      ),
      {
        name: 'creator.selection.v1',
        storage: createJSONStorage(() => sessionStorage),
        partialize: (s) => ({
          companyId: s.companyId,
          month: s.month,
          selectedDrivers: s.selectedDrivers,
        }),
      },
    ),
    { name: 'EasyTacho', store: 'creator-selection' },
  ),
)
